import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import style from '../../css/Payment.module.css';
import PaymentOptions from './PaymentMethods';
import "./PaymentProcess.css"
import { getInvoiceByUser } from '../../components/Service/Oder';
import { useFetcher } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
// import { createPayPalOrder } from '../../components/Service/PaypalService';
function PaymentProcess() {
    const [option, setOption] = useState("");
    const [invoice, setinvoice] = useState([]);
    const handleOnSelectedOption = (item) => {
        setOption(item);
    }

    useEffect(() => {
        const fetchData = async () => {
            const data = await getInvoiceByUser();
            setinvoice(data.invoice)
        }
        fetchData();
    }
    )
    const location = useLocation();

    // const sumInvoice = invoice.find(row => row.total)
    const getURL = (item) => {
        const url = new URLSearchParams(location.search);
        return url.get(item);
    }
    const invoiceId = getURL('invoice_id');

    const sumInvoice = invoice && invoice.length > 0 ? invoice.find(row => row.id == invoiceId) : null;

    const handleSelectedPay = async () => {
        // if (option == "paypal") {
        //     const approvalUrl = await createPayPalOrder(invoiceId, sumInvoice?.total);
        //     window.location.href = approvalUrl;
        // }
    }


    return (
        <div className="container">
            <PaymentOptions OnSelectedOption={handleOnSelectedOption} />

            <div className="footer">
                <div className="row">
                    <div className="col-4">
                        <p className="mb-0">Chọn phương thức thanh toán:</p>
                        <p className="font-weight-bold">{option ? option : "Chưa chọn"}</p>
                    </div>
                    <div className="col-4 ">
                        <h4 className="font-weight-bold">{(sumInvoice?.total)}</h4>
                    </div>
                    <div className="col-4 text-center mt-3">
                        <button className="btn btn-primary" onClick={handleSelectedPay}>Thanh toán</button>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default PaymentProcess;
